import React from 'react';

const tabs = [
  { id: 'home', label: 'Главная', icon: (a) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={a ? '#FFCC00' : '#636366'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> },
  { id: 'objects', label: 'Объекты', icon: (a) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={a ? '#FFCC00' : '#636366'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg> },
  { id: 'question', label: 'Вопрос', icon: (a) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={a ? '#FFCC00' : '#636366'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> },
  { id: 'events', label: 'События', badge: true, icon: (a) => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={a ? '#FFCC00' : '#636366'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg> },
  { id: 'other', label: 'Другое', icon: (a) => <svg width="22" height="22" viewBox="0 0 24 24" fill={a ? '#FFCC00' : '#636366'} stroke="none"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg> },
];

// Под-страницы, живущие внутри вкладки «Другое» — при них подсвечиваем «Другое».
const OTHER_SUBPAGES = ['other', 'library', 'partner', 'expert-topics'];

export default function TabBar({ active, onChange, eventCount = 0 }) {
  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      background: 'rgba(14,14,14,0.88)',
      backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)',
      borderTop: '1px solid var(--border)',
      display: 'flex', justifyContent: 'space-around',
      padding: '8px 0 0',
      paddingBottom: 'calc(8px + var(--tg-safe-bottom, 0px))',
      zIndex: 100,
    }}>
      {tabs.map(tab => {
        const isActive = tab.id === 'other'
          ? OTHER_SUBPAGES.includes(active)
          : active === tab.id;
        return (
          <div key={tab.id}
            onClick={() => onChange(tab.id)}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center',
              gap: 3, padding: '4px 0 6px', cursor: 'pointer', minWidth: 56,
              position: 'relative',
            }}
          >
            <div style={{ position: 'relative', height: 24, display: 'flex', alignItems: 'center' }}>
              {tab.icon(isActive)}
              {tab.badge && eventCount > 0 && (
                <span style={{
                  position: 'absolute', top: -3, right: -12,
                  background: 'var(--accent)', color: '#0A0A0A',
                  fontSize: 9, fontWeight: 800,
                  minWidth: 15, height: 15, borderRadius: 8,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  padding: '0 3px',
                }}>{eventCount}</span>
              )}
            </div>
            <span style={{
              fontSize: 10, fontWeight: 600, letterSpacing: 0.1,
              color: isActive ? 'var(--accent)' : 'var(--text-tertiary)',
              transition: 'color 0.15s',
            }}>{tab.label}</span>
          </div>
        );
      })}
    </div>
  );
}
